const weightLossProcessor=(element)=>
{
let assembledElement=" weight loss"

if (element["Approx_Previous_Weight_(kg)"] !== "")
    {
    assembledElement +=` from ${element["Approx_Previous_Weight_(kg)"]} kg`
    }

if (element["Approx_Weight_Now_(kg)"] !== "")
    {
    assembledElement += ` to ${element["Approx_Weight_Now_(kg)"]} kg`
    }

if ((element["Approx_Previous_Weight_(kg)"] !== "") && (element["Approx_Weight_Now_(kg)"] !== ""))
    {
    let percentWeightLoss= Math.round(100*(element["Approx_Previous_Weight_(kg)"] - element["Approx_Weight_Now_(kg)"]) / element["Approx_Previous_Weight_(kg)"])

    assembledElement += ` (${percentWeightLoss}% loss of weight)`
    }

    if (element["Duration:"] !== "")
    {
    assembledElement += ` over several ${element["Duration:"].toLowerCase()}`
    }

 


return (assembledElement)
}


export default weightLossProcessor